import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector }       from "react-redux";
import { Dropdown }                       from "semantic-ui-react";
import GetOffices                         from "../../../application/usecase/office/GetOffices";
import GetSelectedOffice                  from "../../../application/usecase/office/GetSelectedOffice";
import SelectOffice                       from "../../../application/usecase/office/SelectOffice";
import Account                            from "../../../domain/account/Account";
import OfficeId                           from "../../../domain/office/OfficeId";
import Offices                            from "../../../domain/office/Offices";
import { ResKaState }                     from "../../../index";

const OfficeSelector: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const getOffices: GetOffices = new GetOffices(useDispatch());
  const getSelectedOffice: GetSelectedOffice = new GetSelectedOffice(useDispatch());
  const selectOffice: SelectOffice = new SelectOffice(useDispatch());

  const [offices, setOffices] = useState(new Offices());
  const [selected, select] = useState(new OfficeId());

  useEffect(() => {
    getOffices.execute(setOffices);
    getSelectedOffice.execute(select);
  }, []);

  if (!account.role.isCorporation() || offices.isEmpty()) {
    return null;
  }

  return (
    <>
      <Dropdown
        button
        className="icon"
        icon="building"
        floating
        labeled
        text={ offices.findBy(selected).name.value }
      >
        <Dropdown.Menu>
          {
            offices.toList().map(office => (
              <Dropdown.Item
                key={ office.id.value }
                text={ office.name.value }
                value={ office.id.value }
                selected={ selected.value === office.id.value }
                onClick={ (event, data) => {
                  select(new OfficeId(data.value as number));
                  selectOffice.execute(new OfficeId(data.value as number));
                } }
              />
            ))
          }
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default OfficeSelector;
